export enum SortingCriterionEnum {
  Default = 'default',
  InsurerAsc = 'insurerName:asc',
  InsurerDesc = 'insurerName:desc',
  MedicalCostsDesc = 'medicalExpenses.insuranceSum:desc',
  PriceAsc = 'price.finalPrice:asc',
  PriceDesc = 'price.finalPrice:desc',
}

export enum SortingCriterionLabelEnum {
  SortFromCheapest = 'Sortuj od najtańszych',
  SortFromMostExpensive = 'Sortuj od najdroższych',
  MedicalCostsDescending = 'Koszty leczenia - najwyższe',
  InsurerAscending = 'Ubezpieczyciel – od A do Z',
  InsurerDescending = 'Ubezpieczyciel – od Z do A',
  FromMostExpensive = 'Od najdroższych',
  FromCheapest = 'Od najtańszych',
  FromCheapestShort = 'Cena - najniższa',
  FromMostExpensiveShort = 'Cena - najwyższa',
  MedicalCostsDescendingShort = 'KL - najwyższe',
  InsurerAscendingShort = 'Firma - od A do Z',
  InsurerDescendingShort = 'Firma - od Z do A',
}
